<template>
  <div>
    <Sidebar v-if="isAuthenticated" />
    <Navbar />
    <Toaster />
    <LoadingBottomCard
      v-if="showProgress"
      :processed="processed"
      :enqueued="enqueued"
    />
    <div class="p-2 px-3" style="overflow-x: hidden">
      <router-view />
    </div>
    <MaintenanceModal />
    <CookiesUsage localStorageKey="science-cookieAccept" />
    <DevServerModal
      :mainPath="productionURL_"
      :devPath="devProductionURL_"
      sessionKey="science-iKnowThatItIsDev"
    />
  </div>
</template>

<script lang="ts">
import io, { Socket } from 'socket.io-client'
import { BModal } from 'bootstrap-vue'
import { Component, Vue, Watch } from 'vue-property-decorator'

import { socketPath, socketURL } from '@/api/httpAxios'

import Navbar from '@/components/pages/home/components/navbar/index.vue'
import Sidebar from '@/components/pages/home/components/sidebar/index.vue'

import { userMappers } from '@/store/modules/user'
import { loadingMapper } from '@/store/modules/loading'
import { toastMapper } from '@/store/modules/toast'
import { notificationsMapper } from '@/store/modules/notifications'
import { MaintenanceInfo } from 'interfaces/notifications'
import MobileWidthMixin from '@/mixins/mobile'
import Toaster from '@/components/pages/home/components/Toaster.vue'
import { devProductionURL, productionURL } from '@/config/urls'
import Config from '@/config/default/config'
import MaintenanceModal from '@/components/pages/home/components/MaintenanceModal.vue'

const Mappers = Vue.extend({
  computed: {
    ...userMappers.mapGetters(['isAuthenticated']),
    ...userMappers.mapState(['clientVersion', 'isBadLogin']),
    ...loadingMapper.mapGetters(['showProgress']),
    ...loadingMapper.mapState(['processed', 'enqueued'])
  },
  methods: {
    ...notificationsMapper.mapMutations(['setMaintenanceInfo']),
    ...toastMapper.mapActions(['pushToast']),
    ...userMappers.mapMutations(['setUser'])
  }
})

@Component({
  components: {
    Navbar,
    Toaster,
    Sidebar,
    MaintenanceModal
  },
  mixins: [MobileWidthMixin]
})
export default class Home extends Mappers {
  private productionURL_ = productionURL
  private devProductionURL_ = devProductionURL

  $refs!: { modal: BModal }
  private socket!: typeof Socket

  mounted() {
    if (this.clientVersion) {
      const clientVersion = window.localStorage.getItem('client-version')
      if (clientVersion !== this.clientVersion.commit) {
        window.localStorage.setItem('client-version', this.clientVersion.commit)
        window.location.reload()
      }
    }

    if (!this.isAuthenticated) {
      return
    }
    this.socket = io(socketURL, { path: socketPath })

    this.socket.on('connect', () => {
      this.socket.emit('get-maintenance')
    })

    this.socket.on('maintenance-info', (data: MaintenanceInfo) => {
      this.setMaintenanceInfo(data)
    })
  }

  @Watch('isBadLogin')
  onBadLogin(isBadLogin: boolean) {
    if (this.isAuthenticated && isBadLogin) {
      this.pushToast({
        error: true,
        message: 'Для выполнения действия необходимо войти в систему'
      })
      this.setUser(null)
      this.$router.push(Config.routing.authPage.path)
    }
  }

  onReload() {
    location.reload()
  }
}
</script>
